import * as React from "react";
import { forwardRef } from "react";
const SvgPause = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 6, y: 4, width: 4, height: 16, rx: 1, fill: "currentColor" }), /* @__PURE__ */ React.createElement("rect", { x: 14, y: 4, width: 4, height: 16, rx: 1, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPause);
export default ForwardRef;
